import React, { Component } from 'react'

export class MapContainer extends Component {
  render() {
    return (
      <iframe
        title="google maps"
        src="https://maps.google.com/maps?q=
                  Wood%20Wizards%20Narborough&t=&z=13&ie=UTF8&iwloc=&output=embed"
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
      />
    )
  }
}

export default MapContainer
